/** Shared TailAdmin-style classes for admin list/form pages. */

export const adminPageClass = "space-y-6";

export const adminCardClass =
  "overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-theme-sm dark:border-gray-800 dark:bg-white/[0.03]";

export const adminCardPaddingClass = "p-5 lg:p-6";

export const adminCardHeaderClass =
  "border-b border-gray-200 px-5 py-4 dark:border-gray-800";

export const adminPrimaryButtonClass =
  "inline-flex items-center justify-center rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-brand-600 disabled:cursor-not-allowed disabled:opacity-50";

export const adminSecondaryButtonClass =
  "inline-flex items-center justify-center rounded-lg border border-gray-200 bg-white px-4 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-300 dark:hover:bg-white/5";

export const adminDangerLinkClass =
  "text-sm font-medium text-error-600 transition-colors hover:text-error-700 dark:text-error-400";

export const adminEditLinkClass =
  "text-sm font-medium text-brand-600 transition-colors hover:text-brand-700 dark:text-brand-400";

export const adminViewLinkClass =
  "text-sm font-medium text-gray-600 transition-colors hover:text-gray-900 dark:text-gray-400 dark:hover:text-white/90";

/** Wrap View / Edit / Delete so they stay spaced (never "ViewEditDelete"). */
export const adminTableActionsClass =
  "flex items-center justify-end gap-3";

export const adminAlertErrorClass =
  "rounded-xl border border-error-200 bg-error-50 px-4 py-3 text-sm text-error-700 dark:border-error-500/30 dark:bg-error-500/10 dark:text-error-400";

export const adminTableWrapperClass = "overflow-x-auto";

export const adminTableClass = "min-w-full divide-y divide-gray-200 dark:divide-gray-800";

export const adminTableHeadClass = "bg-gray-50 dark:bg-white/[0.02]";

export const adminTableThClass =
  "px-5 py-3 text-start text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400";

export const adminTableThSortableClass =
  "cursor-pointer px-5 py-3 text-start text-xs font-medium uppercase tracking-wide text-gray-500 transition-colors hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200";

export const adminTableTdClass =
  "px-5 py-4 text-sm text-gray-900 dark:text-white/90";

export const adminTableEmptyClass =
  "px-5 py-8 text-center text-sm text-gray-500 dark:text-gray-400";

export const adminSpinnerClass =
  "h-8 w-8 animate-spin rounded-full border-2 border-gray-200 border-t-brand-500";

export const adminSpinnerSmClass =
  "h-6 w-6 animate-spin rounded-full border-2 border-gray-200 border-t-brand-500";

export const adminPaginationActiveClass =
  "rounded-lg bg-brand-500 px-3 py-1 text-sm font-medium text-white";

export const adminPaginationInactiveClass =
  "rounded-lg bg-gray-100 px-3 py-1 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-200 dark:bg-white/5 dark:text-gray-300 dark:hover:bg-white/10";

export const adminInputInlineClass =
  "w-full rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm text-gray-900 shadow-theme-xs focus:border-brand-300 focus:outline-none focus:ring-2 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90";

/** Default responsive field grid for full-width admin forms. */
export const adminFormGridClass =
  "grid w-full grid-cols-1 gap-6 sm:grid-cols-2 xl:grid-cols-3";

export const adminFormSectionTitleClass =
  "text-base font-semibold text-gray-900 dark:text-white/90";

/** Span all columns (notes, textareas, tables). */
export const adminFormFullWidthClass = "sm:col-span-2 xl:col-span-3";

/** Mobile list: card stack (phones / small tablets). Pair with `hidden lg:block` tables. */
export const adminMobileListClass = "flex flex-col gap-3 lg:hidden";

export const adminMobileCardClass =
  "rounded-2xl border border-gray-200 bg-white p-4 shadow-theme-sm transition-transform active:scale-[0.985] dark:border-gray-800 dark:bg-white/[0.03]";

export const adminMobileCardHeaderClass =
  "flex items-start justify-between gap-3";

export const adminMobileCardTitleClass =
  "text-[15px] font-semibold leading-snug text-gray-900 dark:text-white/90";

export const adminMobileCardMetaClass =
  "mt-0.5 text-[13px] leading-snug text-gray-500 dark:text-gray-400";

export const adminMobileCardBodyClass =
  "mt-3 space-y-2 border-t border-gray-100 pt-3 dark:border-gray-800";

export const adminMobileRowClass =
  "flex items-start justify-between gap-3 text-[13px]";

export const adminMobileRowLabelClass =
  "shrink-0 text-gray-500 dark:text-gray-400";

export const adminMobileRowValueClass =
  "min-w-0 text-right font-medium text-gray-900 dark:text-white/90";

export const adminMobileCardActionsClass =
  "mt-3 flex gap-2 border-t border-gray-100 pt-3 dark:border-gray-800";

export const adminMobileActionPrimaryClass =
  "inline-flex h-11 flex-1 items-center justify-center rounded-xl bg-brand-500 text-sm font-semibold text-white transition-colors hover:bg-brand-600 active:bg-brand-700";

export const adminMobileActionSecondaryClass =
  "inline-flex h-11 flex-1 items-center justify-center rounded-xl border border-gray-200 bg-white text-sm font-semibold text-gray-700 transition-colors hover:bg-gray-50 active:bg-gray-100 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200 dark:hover:bg-white/5";

export const adminMobileBadgeClass =
  "inline-flex shrink-0 items-center rounded-full px-2.5 py-1 text-[11px] font-semibold leading-none";
